/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MensagemDetalhesAliases {
  CONTEXTUAL_BAR_MENSAGEM = 'contextual-bar-mensagem',
  FETCH_ANEXOS = 'fetch-anexos',
  FETCH_MENSAGEM = 'fetch-mensagem',
  FIELD_ANEXOS = 'field-anexos',
  FIELD_DATA_LIBERACAO = 'field-data-liberacao',
  FIELD_DESCRICAO = 'field-descricao',
  FIELD_TITULO = 'field-titulo',
  HPMS_ATTACHMENTS_LIST = 'hpms-attachments-list',
  HPMS_CUSTOM_CARD = 'hpms-custom-card',
  HPMS_TEXT_HTML = 'hpms-text-html',
  MAPPER_ATTACHMENT_LIST = 'mapper-attachment-list',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  TEXT_DATA_LIBERACAO = 'text-data-liberacao',
  TEXT_TITULO = 'text-titulo',
}
export { MensagemDetalhesAliases };
